import domainDecoder from './domain'

export default (domains = []) => domains.map(domainDecoder)
